import BaseReducer from './base.reducers';
import { TARGET_TENANT_DOMAIN } from '../../../../config';

let options = {};
options.resourceName='CaseSection';
options.targetTenantDomain = TARGET_TENANT_DOMAIN;
const SupportCaseSectionReducer = new BaseReducer(options);
export const SupportCaseSectionConfig = (state = {}, action) => SupportCaseSectionReducer.item(state, action);
